import cache from "../helpers/cache";
import { DASHBOARD, DASHBOARD_ITEMS, SELECTED_TAB } from "../helpers/config";
import dashboard from "../dashboard/dashboard.json";
import dashboardFilter from "./dashboardFilter";
import time from "./time";
import { toBlob, toPng } from "html-to-image";
import download from "downloadjs";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

const getLocalDashboardItems = () =>
  JSON.parse(window.localStorage.getItem(DASHBOARD_ITEMS));

const getDashboard = () => {
  let dash = cache.getItem(DASHBOARD);
  if (!dash) {
    dash = dashboard
    setDashboard(dash)
  }
  return dash
}

const setLocalDashboardItems = (dashboardItems) => {
  window.localStorage.setItem(
    DASHBOARD_ITEMS,
    JSON.stringify(dashboardItems) || JSON.stringify(dashboard.dashboardItems)
  );
};

const setDashboard = (dash) => {
  cache.setItem(DASHBOARD, dash || dashboard);
};

const getSelectedTab = () => {
  let selectedTab = cache.getItem(SELECTED_TAB)
  if (!selectedTab) {
    selectedTab = "0"
    setSelectedTab(selectedTab)
  }
  return selectedTab
}

const setSelectedTab = (st) => {
  cache.setItem(SELECTED_TAB, st || "0")
}

const getDashboardItemsForTab = (tabIndex) => {
  const data = getDashboard()
  console.log("dashboard", data)
  return {
    dashboardItems: data.dashboardItems
      .filter(dashboardItem =>
        dashboardItem.tabIndex == tabIndex
      )
  }
}

const getDashboardItemAttribute = (id, attributeName) => {
  let attribute = getDashboard().dashboardItems
    .find((item) => {
      return item.id == id
    })?.[attributeName]


  return attribute
}

const uploadToBucket = async (exportProgress, setExportProgress) => {
  setExportProgress({
    ...exportProgress,
    status: "active",
    progress: 0,
    message: "Exporting dashboard",
  });
  console.log(exportProgress);
  const reportId = `report-${uuidv4()}`;
  console.log("reportId: ", reportId);

  let progress = 0;
  let dashboardItems = getLocalDashboardItems();
  // sequential upload
  let uploads = await dashboardItems.reduce(
    async (memo, dashboardItem, index) => {
      const results = await memo;
      progress = Math.floor(((index + 1) * 100) / (dashboardItems.length + 2));
      console.log(index + 1, dashboardItems.length + 2, progress);
      setExportProgress({
        ...exportProgress,
        progress,
        message: "Exporting dashboard",
        status: "active",
      });
      return [...results, await uploadChart(dashboardItem.id, reportId)];
    },
    []
  );

  progress = Math.floor(
    ((dashboardItems.length + 1) * 100) / (dashboardItems.length + 2)
  );
  console.log(dashboardItems.length + 1, dashboardItems.length + 2, progress);
  let con = await uploadConfig(reportId);
  setExportProgress({
    ...exportProgress,
    progress,
    message: "Exporting dashboard",
    status: "active",
  });
  uploads.push(con);

  return { status: uploads.reduce((acc, u) => acc && u), reportId };
};

const uploadChart = async (divId, reportId) => {
  let success;
  try {
    let formData = new FormData();
    formData.append("bucket_name", `${process.env.REACT_APP_EXPORT_BUCKET}`);
    formData.append("file_path", `${reportId}/chart-${divId}`);
    const div = document.getElementById(`render-${divId}`);
    console.log(divId, div, "file_path", `${reportId}/chart-${divId}`);
    const blob = await toBlob(div);

    formData.append("file", blob);
    await axios.post(
      `${process.env.REACT_APP_FILEUPLOAD_API_GCP}/upload`,
      formData
    );
    // setExportProgress({
    //     ...exportProgress,
    //     progress
    // })
    success = true;
    // download(blob, `${divId}-testsave.png`)
  } catch (err) {
    success = false;
    console.log("error saving blob", err);
  } finally {
    return success;
  }
};

const uploadConfig = async (reportId) => {
  let success;
  try {
    let formData = new FormData();

    const configObj = {
      reportId,
      ...dashboardFilter.getDimensionStates(),
      dateRange: time.getDateRange(),
      reportName: `DCD Report Earned Media.pptx`,
      bucketName: process.env.REACT_APP_EXPORT_BUCKET
    };
    const configJson = JSON.stringify(configObj);
    const configbBlob = new Blob([configJson], { type: "application/json" });

    formData.append("bucket_name", `${process.env.REACT_APP_EXPORT_BUCKET}`);
    formData.append("file_path", `${reportId}/config`);
    formData.append("file", configbBlob);

    console.log(formData)

    await axios.post(
      `${process.env.REACT_APP_FILEUPLOAD_API_GCP}/upload`,
      formData
    );
    // download(configbBlob, `config.json`)
    success = true;
  } catch (err) {
    success = false;
    console.log("error uploading config file: ", err);
  } finally {
    return success;
  }
};

const downloadReport = async (reportId, exportProgress, setExportProgress) => {
  let body = {
    bucket_name: process.env.REACT_APP_EXPORT_BUCKET,
    reportId,
  };
  let success;

  try {
    await axios
      .post(`${process.env.REACT_APP_REPORT_API}/gen-report`, body)
      .then((res) => {
        console.log(res)
        setExportProgress({
          ...exportProgress,
          progress: 100,
          status: "success",
          message: "Your report will be downloaded shortly",
        });
        console.log(res.data.download_url);
        let a = document.createElement("a");
        a.target = "_blank";
        a.href = res.data.download_url;
        a.click();

        success = true;
      })
      .catch((err) => {
        console.log("axios error: ", err);
        throw err;
      });
  } catch (err) {
    console.log(err);
    setExportProgress({
      ...exportProgress,
      status: "exception",
      message: "Error downloading report",
    });
    success = false;
  } finally {
    return success;
  }
};

export default {
  getDashboard,
  setDashboard,
  getLocalDashboardItems,
  setLocalDashboardItems,
  getSelectedTab, setSelectedTab,
  getDashboardItemsForTab,
  getDashboardItemAttribute,
  uploadToBucket,
  downloadReport
};
